import styles from "./style.module.scss";

import endLogo from "assets/images/endLogo.png";
import fbLogo from "assets/images/fblogo.png";
import instaLogo from "assets/images/instalogo.png";
import telegramLogo from "assets/images/telegram.png";

const Footer = () => (
  <div className={styles.end}>
    <div className={styles.end__toppanel} />

    <div className={styles.end__description}>
      <div className={styles.end__logo}>
        <img src={endLogo} alt="logo" />
        <p>{`${new Date().getFullYear()} `}</p>
      </div>

      <div className={styles.end__title}>
        <div className={styles.title__socials}>
          <p>Соц.сети:</p>
          <div className={styles.end__logotypes}>
            <a
              href="https://www.instagram.com/formula_tsveta_by/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={instaLogo} alt="instagram" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61557042123639&mibextid=ZbWKwL"
              target="_blank"
              rel="noreferrer"
            >
              <img src={fbLogo} alt="facebook" />
            </a>
            <a
              href="https://t.me/+375257961636"
              target="_blank"
              rel="noreferrer"
            >
              <img src={telegramLogo} alt="telegram" />
            </a>
          </div>
        </div>

        <p className={styles.end__rights}>
          ©{`${new Date().getFullYear()} `} Авторские права: formulatsveta.by
        </p>
      </div>

      <div className={styles.end__column}>
        <h2>Контакты:</h2>
        <a
          className={styles.end__mail}
          href="mailto:formulatsvetaby.23@gmail.com"
        >
          {" "}
          formulatsvetaby.23@gmail.com
        </a>
        <br />
        <a className={styles.end__phone} href="tel:+375 25 796-16-36">
          +375 25 796-16-36
        </a>
        <h2>Адрес:</h2>
        <address>
          <a href="https://maps.app.goo.gl/AEWNJXc954Nhhng89?g_st=it">
            ул. Московская 402, Брест, Брестская область 224004, Беларусь
          </a>
        </address>
      </div>
    </div>
  </div>
);

export default Footer;
